import React, { useEffect, useState } from 'react';
export function FloatingBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) {
              h--;
            } else {
              // Infinite loop reset
              return {
                h: 23,
                m: 59,
                s: 59
              };
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 z-50 animate-fade-in-up" data-id="element-18">
      <a href="https://www.nexorecursos.com/cart/52429003817236:1" className="group relative flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6 p-3 sm:px-6 sm:py-3 bg-gray-900/85 backdrop-blur-md border border-emerald-500/50 rounded-2xl shadow-[0_0_30px_rgba(16,185,129,0.2)] hover:shadow-[0_0_40px_rgba(16,185,129,0.4)] transition-all duration-300 overflow-hidden" data-id="element-19">
        {/* Animated background glow */}
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/0 via-emerald-500/10 to-emerald-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse" data-id="element-20" />

        {/* Text */}
        <div className="relative z-10 flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left" data-id="element-21">
          <span className="flex items-center gap-2 text-white font-bold text-sm sm:text-base" data-id="element-22">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-23" />
            ¡Quedan pocos cupos para OFF-ROAD CEO!
          </span>
          <span className="text-emerald-400 font-extrabold text-sm sm:text-base" data-id="element-24">
            APROVECHALO POR $27.990
          </span>
        </div>

        {/* Timer & Arrow */}
        <div className="relative z-10 flex items-center gap-4" data-id="element-25">
          <div className="flex items-center gap-1 bg-black/50 px-3 py-1.5 rounded-lg border border-gray-700" data-id="element-26">
            <span className="text-emerald-500 font-mono font-bold" data-id="element-27">
              {String(timeLeft.h).padStart(2, '0')}:
              {String(timeLeft.m).padStart(2, '0')}:
              {String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <div className="w-8 h-8 rounded-full bg-emerald-500 text-gray-950 flex items-center justify-center font-bold group-hover:scale-110 transition-transform" data-id="element-28">
            →
          </div>
        </div>
      </a>
    </div>;
}